<div id="toolbarViewerMiddle" [class]="showZoomButtons | responsiveCSSClass : 'always-visible'">
  <pdf-zoom-out [showZoomButtons]="showZoomButtons"></pdf-zoom-out>
  <pdf-zoom-in [showZoomButtons]="showZoomButtons"></pdf-zoom-in>
  <pdf-zoom-dropdown class="reset-width-padding" [zoomLevels]="zoomLevels"> </pdf-zoom-dropdown>
</div>
